<a  *ngIf="showItemForRole" mat-list-item  (click)="onItemSelected(item)"
   [ngClass]="{'active': item.displayName ? checkNavItem(item) : false, 'expanded': item.expandable }"
   class="menu-list-item">
  <div  class="containernav" >
    <div class="firsticon"> <mat-icon class="routeIcon">{{item.iconName}}</mat-icon></div>
    <div class="secondname"><span> {{item.displayName}}</span></div>
    <div class="thirdicon"><span *ngIf="item.children && item.children.length" >
      <span  class="expandFlex"></span>
      <mat-icon>{{item.expandable  ? 'expand_more' : 'chevron_right' }}
       </mat-icon>
    </span></div>
  </div>
</a>
<div *ngIf="item.expandable" id="sublink" >
  <ple-side-nav [permissions]="permissions" [appDrawer]="appDrawer" *ngFor="let child of item.children" [item]="child" [itemList]="item.children" (navigationClicked)="navigationChildClicked(item)">
  </ple-side-nav>
</div>
<ng-template #confirmHMIClose>
  <div class="title">
      <h4 mat-dialog-title>Close session</h4>
  </div>
  <hr class="control-command-error-header">
  <mat-dialog-content class="mat-typography command-cotrol-error-dialog">
    <p>Current session will be terminated. Do you want to exit?</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close style="height: 35px">No</button>
      <button mat-flat-button mat-dialog-close class="mat-button-primary-sm" (click)="exitFromHMITab()">Yes</button>
  </mat-dialog-actions>
</ng-template>